export default "__VITE_ASSET__BUmEUXLC__"